import Box from '@mui/material/Box';
import Card from "@mui/material/Card";
import Link from '@mui/material/Link';
import React from 'react';
import useMyMApi from '../hooks/useMyMApi';
import { MyMImage } from "../ui-elements/MyMImage";
import { MyMLabel } from '../ui-elements/MyMLabel';
import { ItAppFavorite } from '../ui-parts/ContentsFavorite';

/** MyMine Version2.0 共通化に伴い新規作成
 * ItAppImageLinkCard Component
 */
export const ItAppImageLinkCard = (props) => {
  const {
    screenId,
    preCheckFavorite,
    callbackFavorite,
    itApp,
    setIsLoading,
    imageContainerHeight
  } = props;

  const apiRequest = useMyMApi(screenId);

  const navigateItPage = (url, itAppId) => {
    apiRequest.requestJson('api/it-applications/external-link-transition?itAppId=' + itAppId, 'GET');
  };

  /**
  * お気に入り(登録/解除)押下時処理
  * @param {Event} e イベント引数
  * @param {any} itAppId 対象ITApplicationId
  */
  const onClickFavorite = (e, favItApp) => {
    e.preventDefault();

    if (preCheckFavorite && preCheckFavorite(favItApp.ItAppId) === false)
      return;

    setIsLoading(true);
    const callbackFavoriteSuccess = () => {
      callbackFavorite && callbackFavorite(favItApp.ItAppId);
      setIsLoading(false);
    }

    const callbackFavoriteFailed = () => {
      setIsLoading(false);
    }

    apiRequest.requestJson(`api/it-applications/favorite`, 'POST', callbackFavoriteSuccess, callbackFavoriteFailed, { Key: favItApp.ItAppId, Unfavorite: itApp.IsFavorite })
  };

  return (
   
      <Card variant="outlined" sx={{ height: '100%', width: "100%", borderRadius: '35px', border: '2px solid #777777', margin: "5px 0px 5px 3px" }}>
        <Box position="relative" display="inline-block" textAlign="center" width="100%">
          <Box className='text-end pe-2'>
            <ItAppFavorite isFavorite={itApp.IsFavorite} favoriteAction={(e) => { onClickFavorite(e, itApp) }} unFavoriteAction={(e) => { onClickFavorite(e, itApp) }} />
          </Box>
        <Box height={imageContainerHeight} className='d-flex align-items-center justify-content-center'>
          <Link href={itApp.ItAppLink} color="inherit" target="_blank" underline="none" onClick={() => navigateItPage(itApp.ItAppLink, itApp.ItAppId)}>
            {
              itApp.LogoFileDir
                ? <img
                  src={`api/page/file?fileName=${itApp.LogoFileDir}`}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = `${process.env.PUBLIC_URL}/${screenId}/NoImage.png`;
                  }}
                  alt="ItAppLogo"
                  width="70%"
                  height="auto"
                  display="block"
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto"
                  }}
                />
                : <MyMImage
                  screenId={screenId}
                  filePath='NoImage.png'
                  alt="ItAppLogo"
                  width="70%"
                  height="auto"
                  display="block"
                  sx={{
                    opacity: "0.5", zIndex: "10" }}
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto"
                  }}

                />
            }
          </Link>
          </Box>
        </Box>
        <ITApplicationName
          display="inline-block"
          itAppNameAbb={itApp.ItAppNameAbb}
          itAppNameOfficial={itApp.ItAppNameOfficial}
        />
      </Card>
  );
}

const ITApplicationName = ({ itAppNameAbb, itAppNameOfficial }) => {
  const appName = itAppNameAbb ? `(${itAppNameOfficial})` : itAppNameOfficial;
  return itAppNameOfficial
    ?
    <div>
      <MyMLabel sx={{ textAlign: "center", fontWeight: "bold" }}>{itAppNameAbb}</MyMLabel>
      <MyMLabel sx={{ textAlign: "center", fontWeight: "bold" }}>{appName}</MyMLabel>
    </div>
    : <MyMLabel sx={{ textAlign: "center", fontWeight: "bold" }}>{itAppNameAbb}</MyMLabel>
}